import { render, staticRenderFns } from "./SingleStepCompetition.vue?vue&type=template&id=80c152ce&scoped=true"
import script from "./SingleStepCompetition.vue?vue&type=script&lang=ts&setup=true"
export * from "./SingleStepCompetition.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./SingleStepCompetition.vue?vue&type=style&index=0&id=80c152ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80c152ce",
  null
  
)

export default component.exports